// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".seal-list{display:flex;flex-wrap:wrap;justify-content:center;align-items:center}.seal-list img.brazilian-home-page{margin:0 4px;height:35px}.seal-list img.international-home-page{margin:0 8px;height:35px}.seal-list img.b-corporate{height:48px!important}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
